import config from '@/config/config.js';
import { http } from '@/common/request';
import errorCode from '@/api/error-code.js'
export default {
    /***************************************************** start *******************************************/





    loginByWxCode(code){
        let params = { }
        let data = {
            code:code,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/passport/loginByWxCode",data, method: 'POST', ...options});
    },

    loginByEmail(email, password){
        let params = { }
        let data = {
            email:email,
            password:password,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/passport/loginByEmail",data, method: 'POST', ...options});
    },
    loginByPhone(phone, password, prefix){
        let params = { }
        let data = {
            phone:phone,
            password:password,
            prefix:prefix,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/passport/loginByPhone",data, method: 'POST', ...options});
    },


    userInfoNum(){
        let params = { }
        let data = {

        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/info/infoNum",data, method: 'GET', ...options});
    },




    sendEmailVerifyCode(type, email){
        let params = { }
        let data = {
            type:type,
            email:email,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/passport/sendEmailVerifyCode",data, method: 'POST', ...options});
    },
    sendVerifyPhoneCode(type, phone, prefix="+86"){
        let params = { }
        let data = {
            type:type,
            phone:phone,
            prefix:prefix,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/passport/sendVerifyPhoneCode",data, method: 'POST', ...options});
    },

    registerByEmail(email, key, code , password, inviteCode, phone,wxUnionid=null){
        let params = { }
        let data = {
            email:email,
            key:key,
            code:code,
            password:password,
            inviteCode:inviteCode,
            phone:phone,
            wxUnionid:wxUnionid,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/passport/registerByEmail",data, method: 'POST', ...options});
    },


    registerByPhone(prefix, phone, key, code , password, inviteCode,wxUnionid=null){
        let params = { }
        let data = {
            prefix:prefix,
            phone:phone,
            key:key,
            code:code,
            password:password,
            inviteCode:inviteCode,
            wxUnionid:wxUnionid,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/passport/registerByPhone",data, method: 'POST', ...options});
    },




    modifyPasswordByPhone(prefix, phone, key, code , password){
        let params = { }
        let data = {
            prefix:prefix,
            phone:phone,
            key:key,
            code:code,
            password:password,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/passport/modifyPasswordByPhone",data, method: 'POST', ...options});
    },


    modifyPasswordByEmail(email, key, code , password){
        let params = { }
        let data = {
            email:email,
            key:key,
            code:code,
            password:password,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/passport/modifyPasswordByEmail",data, method: 'POST', ...options});
    },


    addCart(productId, skuId, regionId , num){
        let params = { }
        let data = {
            productId:productId,
            skuId:skuId,
            regionId:regionId,
            num:num,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/cart/addCart",data, method: 'POST', ...options});
    },

    removeCart(cartIds){
        let params = { }
        let data = {
            cartIds:cartIds,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/cart/removeCart",data, method: 'POST', ...options});
    },
    updateCartNum(cartId, num){
        let params = { }
        let data = {
            cartId:cartId,
            num:num,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/cart/updateCartNum",data, method: 'POST', ...options});
    },
    moveCartToCollect(cartIds){
        let params = { }
        let data = {
            cartIds:cartIds,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/cart/moveToCollect",data, method: 'POST', ...options});
    },
    getUserCarts(){
        let params = { }
        let data = {

        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/cart/getUserCarts",data, method: 'GET', ...options});
    },

    collectProductsFilter(filter){
        let params = { }
        let data =filter
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/collect/userCollectProductFilter",data, method: 'GET', ...options});
    },

    collectProducts(productIds){
        let params = { }
        let data = {
            productIds:productIds,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/collect/collectProducts",data, method: 'POST', ...options});
    },
    deleteCollectProducts(productIds){
        let params = { }
        let data = {
            productIds:productIds,
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/collect/deleteProducts",data, method: 'POST', ...options});
    },


    userAddress(){
        let params = { }
        let data = {

        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/address/all",data, method: 'GET', ...options});
    },

    modifyUserAddress(req){
        let params = { }
        let data = req
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/address/modifyAddress",data, method: 'POST', ...options});
    },

    addUserAddress(req){
        let params = { }
        let data = req
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/address/addAddress",data, method: 'POST', ...options});
    },

    deleteUserAddress(addressId){
        let params = { }
        let data = {
            addressId:addressId
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/address/deleteAddress",data, method: 'POST', ...options});
    },

    setDefaultAddress(addressId){
        let params = { }
        let data = {
            addressId:addressId
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/address/setDefaultAddress",data, method: 'POST', ...options});
    },

    userBasicInfo(){
        let params = { }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/info/userBasicInfo",data, method: 'GET', ...options});
    },

    userVerifyInfo(){
        let params = { }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/info/userVerifyInfo",data, method: 'GET', ...options});
    },

    userVerify(data){
        let params = { }
        // let data = {
        // let data = {
        // }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/user/info/userVerify",data, method: 'POST', ...options});
    },

    userKefuInfo(){
        let params = { }
        // let data = {
        // let data = {
        // }
        const options = {};
        options.params = params;
        const data = {};
        return  http.request({url:"/api/v3/user/info/kefuInfo",data, method: 'GET', ...options});
    }


    /***************************************************** end *********************************************/
}
